export interface ITicketsCountItem  {
    Status: string;
    AdminID: number;
    Total: number;

}

export class TicketsCountItemArray extends Array<TicketsCountItem>  {

    constructor(...items: TicketsCountItem[]) {
        super(...items);
        Object.setPrototypeOf(this, TicketsCountItemArray.prototype);
    }

}

export class TicketsCountItem  implements ITicketsCountItem {
    Status: string;
    AdminID: number;
    Total: number;
}
